import { IconProps } from "./types";

const AuditIcon: React.FC<IconProps> = ({ className }) => {
  return <img className={className} src="../../assets/images/audit.svg" alt="" />;
};

export default AuditIcon;
